import React from "react";
import styles from "./Jobs.module.css";
import jobs from "../data/jobs";
import JobCard from "../components/JobCard";


const Jobs: React.FC = () => {



  const openings = jobs.filter((j) => j.isOpen === true);
  const openingsCount = openings.length;
  const hasOpenings = openingsCount > 0;

  return (
    <main className={styles.jobsPage}>

      
      <div className={styles.inner} id="openings">
        <header className={styles.header}>
          <h2 className={styles.sectionTitle}>
            Offene Stellen
            {openingsCount > 0 && (
              <span
                className={styles.countPill}
                aria-label={`Anzahl: ${openingsCount}`}
              >
                {openingsCount}
              </span>
            )}
          </h2>

          <p className={styles.subtitle}>
            Gestalten Sie mit uns die Zukunft – wir freuen uns auf Ihre Bewerbung!
          </p>

          {!hasOpenings && (
            <p className={styles.statusLine} role="status" aria-live="polite">
              Aktuell liegen keine veröffentlichten Stellen vor. Wir freuen uns über Ihre{" "}
              <strong>Initiativbewerbung</strong>.
            </p>
          )}
        </header>

    
        {hasOpenings && (
          <div className={styles.cardGrid}>
            {openings.map((job, index) => (
              <JobCard key={job.id} {...job} delay={index * 100} />
            ))}
          </div>
        )}

     
        <section
          className={styles.cta}
          aria-live={!hasOpenings ? "polite" : undefined}
        >
          <h3>Initiativbewerbung</h3>

          <p>
            Senden Sie uns gern Ihre Unterlagen an{" "}
            <br />
            <a
              href="mailto:bewerbung@avila-gruppe.de?subject=Initiativbewerbung AVILA"
              className={styles.emailLink}
            >
      bewerbung@avila-gruppe.de
            </a>
            .
          </p>

          <ul className={styles.reqList}>
            <li>
              <strong>Lebenslauf</strong>
              <span className={styles.meta}>(max. 2&nbsp;Seiten)</span>
            </li>
            <li>
              <strong>Kurzes Anschreiben</strong>
              <span className={styles.meta}>
                (Motivation, gewünschter Aufgabenbereich, ggf. Verfügbarkeit &amp; Gehaltsvorstellung)
              </span>
            </li>
            <li>
              <strong>Relevante Zeugnisse / Zertifikate</strong>
            </li>
            <li>
              <strong>Portfolio / Arbeitsproben</strong>
              <span className={styles.meta}>(optional; PDF oder Link)</span>
            </li>
            <li>
              <strong>Frühestmöglicher Eintrittstermin</strong>
            </li>
            <li>
              <strong>Kontaktdaten</strong>
              <span className={styles.meta}>(Telefon, E-Mail)</span>
            </li>
          </ul>

          <p>Wir behandeln Ihre Unterlagen vertraulich.</p>
        </section>
      </div>
    </main>
  );
};

export default Jobs;
